module.exports = __webpack_public_path__ + "img/logo-large.99c85565.png";